import React from 'react';
import { SchoolAdmin } from '../../models/Admin';
import { Link, useHistory } from 'react-router-dom';
import useSchoolsAdmins from '../../services/swr/useSchoolAdmins';
import MutableListItemOptions from '../../components/MutableListItemOptions';

interface ComponentProps {
  adminInfo: SchoolAdmin;
}

const SchoolAdminListItem = ({ adminInfo }: ComponentProps) => {
  const { handleDeleteSchoolAdmin } = useSchoolsAdmins();
  const { push } = useHistory();

  const handleDelete = () => handleDeleteSchoolAdmin(adminInfo.id);

  return (
    <li className="mb-4 last:mb-0 flex items-center justify-between">
      <Link to={`/teacher-details/${adminInfo.id}`} className="no-underline">
        <article>
          <p className="font-sans text-xl text-black font-medium">
            {adminInfo.name}
          </p>
          <p className="font-sans text-xl text-black">{adminInfo.email}</p>
        </article>
      </Link>
      <MutableListItemOptions
        objectName={adminInfo.name || adminInfo.id}
        onEdit={() => push(`/teacher-details/${adminInfo.id}`)}
        onRemove={handleDelete}
      />
    </li>
  );
};

export default SchoolAdminListItem;
